export default __webpack_public_path__ + "static/char-v-29-ja-c4744b3bd17eb272bac15f8a2c11c547.mp4";